/**
 * Cache em memória dos dados de relatório.
 *
 * Mora num módulo próprio, sem dependências, por dois motivos:
 *
 *  1. O AuthContext precisa limpá-lo ao trocar de conta e no logout. Importar
 *     `useReportData` lá arrastaria `@/utils/api` e `import.meta.env` para
 *     dentro de qualquer teste do contexto de autenticação.
 *  2. A chave do cache é a URL, e o accountId viaja no cookie — nunca na URL.
 *     Duas contas diferentes geram exatamente a mesma chave, então este módulo
 *     carrega o dono do cache e se descarta sozinho quando a conta muda.
 */

const cache = new Map();

/** Conta a que o conteúdo atual do cache pertence. */
let cacheOwner = null;

export const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

/**
 * Descarta o cache quando a conta ativa mudou.
 *
 * `clearReportCache()` também é chamado no switchAccount e no logout, mas isso
 * depende de alguém lembrar; este carimbo fecha o vetor mesmo que um caminho
 * novo de troca de conta esqueça.
 */
export function assertCacheOwner(accountId) {
    if (accountId && cacheOwner !== accountId) {
        cache.clear();
        cacheOwner = accountId;
    }
}

export function getCached(key) {
    const entry = cache.get(key);
    if (!entry) return null;
    if (Date.now() - entry.timestamp >= CACHE_TTL) {
        cache.delete(key);
        return null;
    }
    return entry.data;
}

export function setCached(key, data) {
    cache.set(key, { data, timestamp: Date.now() });
}

export function deleteCached(key) {
    cache.delete(key);
}

/** Limpa tudo. Chamado ao trocar de conta e no logout. */
export function clearReportCache() {
    cache.clear();
    cacheOwner = null;
}
